import React, { useCallback, useState } from 'react';

import { Button, Grid, IconButton, InputAdornment, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

export default ({ onCriteriaChange, onAddDiscount }) => {
  const [keyword, setKeyword] = useState('');

  const onSearchChange = useCallback((event) => {
    setKeyword(event.target.value);
  }, []);

  const onSearchClick = () => {
    onCriteriaChange({ keyword });
  };

  return (
    <Grid container justify="flex-end" alignItems="center">
      <Grid item xs={12} sm={6} style={{ textAlign: 'left' }}>
        <Button onClick={onAddDiscount} variant="contained" color="primary">
          Add Discount
        </Button>
      </Grid>

      <Grid item xs={12} sm={6} container justify="flex-end">
        <TextField
          onChange={onSearchChange}
          onKeyUp={(e) => {
            if (e.key === 'Enter') onSearchClick();
          }}
          placeholder="Search"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={onSearchClick}>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          type="text"
        />
      </Grid>
    </Grid>
  );
};
